// Reseñas de producto -- lectura pública (solo las aprobadas por un
// admin), publicación requiere cuenta (JWT). El backend valida que el
// usuario tenga un pedido "entregado" con ese producto antes de aceptar
// la reseña; acá no se duplica esa lógica, solo se muestra el error que
// devuelva.
import { request } from './ecommerceClient';
import { getStoredAuth } from './auth';

const authParams = () => {
  const { token } = getStoredAuth();
  return token ? { token } : {};
};

export const getResenasProducto = (productoId) => request(`/productos/${productoId}/resenas`);

export const crearResena = ({ productoId, rating, comentario }) =>
  request('/resenas', {
    method: 'POST',
    params: authParams(),
    body: JSON.stringify({ producto_id: productoId, rating, comentario }),
  });
